function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var crunion = function crunion(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "23",
    viewBox: "0 0 40 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.89999 5.875V1H39V18.55H34.125",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "5.9",
    width: "33.1",
    height: "15.55",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.434 15.846C21.434 12.85 16.856 13.046 16.856 11.562C16.856 10.96 17.304 10.568 18.088 10.568C18.97 10.568 19.39 11.114 19.39 11.87V11.968H21.364V11.674C21.364 10.176 20.37 9.14001 18.802 8.91601V7.71201H17.402V8.93001C15.708 9.15401 14.756 10.302 14.756 11.646C14.756 14.516 19.348 14.446 19.348 15.902C19.348 16.546 18.956 17.008 18.018 17.008C17.178 17.008 16.52 16.588 16.52 15.664V15.468H14.546V15.958C14.546 17.442 15.666 18.478 17.374 18.674V19.864H18.774V18.66C20.538 18.38 21.434 17.246 21.434 15.846Z",
    fill: "black"
  }));
};

export default crunion;